import { AddCategoryModel } from '../../components/add-category/addCategoryInterfaces';

import { axiosInstance } from '../axios';
import { ApiResponse } from '../models/ApiResponse';
import { Category } from '../models/Category';

export const GetAllCategories = async () => {
  const result = await axiosInstance.get<ApiResponse<Category[]>>('reports/categories');
  return result.data.data;
};

export const AddCategory = async (category: AddCategoryModel) => {
  const result = await axiosInstance.post<ApiResponse<Category>>('reports/categories', category);
  if (result.status === 200) {
    return result.data.data;
  } else {
    //todo: add a toast message here
  }

  return null;
};

export const CheckCategoryExists = async (category: AddCategoryModel) => {
  const result = await axiosInstance.post<ApiResponse<boolean>>('reports/category/exists', category);
  if (result.status === 200) {
    return result.data.data;
  } else {
    //todo: add a toast message here
  }

  return true;
};
